(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  const easternDateFormatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  });

  function parseEasternDeadline(dateText, timeText) {
    const dateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateText || '');
    const timeMatch = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(timeText || '');
    if (!dateMatch || !timeMatch) return null;

    const [, yearText, monthText, dayText] = dateMatch;
    const [, hourText, minuteText] = timeMatch;
    const year = Number(yearText);
    const month = Number(monthText);
    const day = Number(dayText);
    const hour = Number(hourText);
    const minute = Number(minuteText);
    const localAsUtc = Date.UTC(year, month - 1, day, hour, minute);
    const validDate = new Date(localAsUtc);
    if (validDate.getUTCFullYear() !== year || validDate.getUTCMonth() + 1 !== month || validDate.getUTCDate() !== day) {
      return null;
    }

    // Eastern Time uses UTC-4 or UTC-5. Matching both rejects repeated fall-back times;
    // matching neither rejects skipped spring-forward times.
    const matches = [4, 5].map((offset) => localAsUtc + offset * 60 * 60 * 1000).filter((candidate) => {
      const parts = Object.fromEntries(easternDateFormatter.formatToParts(candidate).map(({ type, value }) => [type, value]));
      return Number(parts.year) === year && Number(parts.month) === month && Number(parts.day) === day
        && Number(parts.hour) === hour && Number(parts.minute) === minute;
    });

    return matches.length === 1 ? matches[0] : null;
  }

  function getCountdownParts(deadline, now) {
    const remaining = Math.max(0, Math.ceil((deadline - now) / 1000));
    return {
      days: Math.floor(remaining / 86400),
      hours: Math.floor((remaining % 86400) / 3600),
      minutes: Math.floor((remaining % 3600) / 60),
      seconds: remaining % 60,
    };
  }

  function getCountdownSchedule(endDate, endTime, startDate, startTime) {
    const deadline = parseEasternDeadline(endDate, endTime);
    const hasStart = Boolean(startDate || startTime);
    const start = hasStart ? parseEasternDeadline(startDate, startTime) : null;
    if (deadline === null || (hasStart && (start === null || start >= deadline))) return null;
    return { start, deadline };
  }

  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-announcement-track]');
      this.toggleButton = this.querySelector('[data-announcement-toggle]');
      this.querySelector('[data-announcement-slide-clone]')?.remove();
      this.allSlides = Array.from(this.querySelectorAll('[data-announcement-slide]'));
      this.slides = [];
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.currentSlide = 0;
      this.slideCount = 0;
      this.isPaused = false;
      this.onTransitionEnd = this.handleTransitionEnd.bind(this);
      this.onClick = this.handleClick.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);
      this.onToggleClick = this.handleToggleClick.bind(this);
      this.onVisibilityChange = this.handleVisibilityChange.bind(this);
      this.onBlockSelect = this.handleBlockSelect.bind(this);
      this.onBlockDeselect = this.handleBlockDeselect.bind(this);

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.toggleButton?.addEventListener('click', this.onToggleClick);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      this.track?.addEventListener('transitionend', this.onTransitionEnd);
      if (this.dataset.designMode === 'true') {
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      this.countdowns = Array.from(this.querySelectorAll('[data-announcement-countdown]')).map((element) => {
        const schedule = getCountdownSchedule(
          element.dataset.endDate, element.dataset.endTime, element.dataset.startDate, element.dataset.startTime,
        );
        const error = element.parentElement.querySelector('[data-countdown-error]');
        element.hidden = schedule === null;
        if (error) error.hidden = schedule !== null;
        element.removeAttribute('data-initializing');
        return { element, slide: element.closest('[data-announcement-slide]'), schedule };
      });
      this.updateCountdowns();
      if (this.countdowns.some(({ schedule }) => schedule && schedule.deadline > Date.now())) {
        this.countdownTimer = window.setInterval(() => this.updateCountdowns(), 1000);
      }
    }

    disconnectedCallback() {
      this.stop();
      if (this.countdownTimer) window.clearInterval(this.countdownTimer);
      this.countdownTimer = null;
      document.removeEventListener('visibilitychange', this.onVisibilityChange);

      if (this.track) {
        this.track.removeEventListener('transitionend', this.onTransitionEnd);
      }

      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.toggleButton?.removeEventListener('click', this.onToggleClick);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      this.loopClone?.remove();
      this.loopClone = null;
      this.editorSelectedSlide = null;
    }

    start() {
      this.stop();
      if (document.hidden || this.isPaused || this.slideCount < 2 || this.reducedMotion.matches || this.editorSelectedSlide) {
        return;
      }

      const interval = Number(this.dataset.interval) || 5000;

      this.timer = window.setInterval(() => {
        if (document.hidden) {
          this.stop();
          return;
        }
        if (this.currentSlide >= this.slideCount) this.resetActiveSlide();
        this.currentSlide += 1;
        this.setActiveSlide(this.currentSlide);
      }, interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    updateCountdowns() {
      const now = Date.now();
      let hasFutureDeadline = false;
      for (const { element, slide, schedule } of this.countdowns) {
        const active = schedule && (schedule.start === null || now >= schedule.start) && now < schedule.deadline;
        slide.hidden = !active && slide !== this.editorSelectedSlide;
        if (schedule) {
          if (schedule.deadline > now) hasFutureDeadline = true;
          this.renderCountdown(element, schedule.deadline, now);
        }
      }
      this.updateSlides();
      if (this.loopClone) {
        const firstCountdown = this.countdowns.find(({ slide }) => slide === this.slides[0]);
        if (firstCountdown?.schedule) {
          this.renderCountdown(this.loopClone.querySelector('[data-announcement-countdown]'), firstCountdown.schedule.deadline, now);
        }
      }
      if (!hasFutureDeadline && this.countdownTimer) {
        window.clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    }

    renderCountdown(element, deadline, now) {
      for (const [unit, value] of Object.entries(getCountdownParts(deadline, now))) {
        const number = element.querySelector(`[data-countdown-unit="${unit}"]`);
        const display = String(value);
        if (number && number.textContent !== display) number.textContent = display;
        if (unit === 'days' && number) {
          number.closest('.announcement-bar__countdown-unit').hidden = value === 0;
        }
      }
    }

    updateSlides() {
      const slides = this.allSlides.filter((slide) => !slide.hidden);
      this.hidden = slides.length === 0;
      if (this.toggleButton) this.toggleButton.hidden = slides.length < 2 || this.reducedMotion.matches;
      for (const slide of this.allSlides) {
        slide.toggleAttribute('data-announcement-first-visible', slide === (this.editorSelectedSlide || slides[0]));
      }
      if (slides.length === this.slides.length && slides.every((slide, index) => slide === this.slides[index])) return;

      const activeSlide = this.slides[this.currentSlide % this.slideCount];
      this.stop();
      this.loopClone?.remove();
      this.loopClone = null;
      this.slides = slides;
      this.slideCount = slides.length;
      this.currentSlide = Math.max(0, slides.indexOf(activeSlide));
      if (!this.track) return;
      this.track.style.transition = 'none';
      this.setActiveSlide(this.currentSlide);
      if (this.slideCount > 1 && !this.reducedMotion.matches) this.createLoopClone();
      this.track.offsetHeight;
      this.track.style.transition = '';
      this.start();
    }

    handleBlockSelect(event) {
      this.editorSelectedSlide = this.allSlides.find((slide) => slide.dataset.blockId === event.detail.blockId);
      this.updateCountdowns();
      const index = this.slides.indexOf(this.editorSelectedSlide);
      if (index >= 0) {
        this.currentSlide = index;
        this.setActiveSlide(index);
      }
      this.stop();
    }

    handleBlockDeselect() {
      this.editorSelectedSlide = null;
      this.updateCountdowns();
      this.start();
    }

    setPaused(paused) {
      this.isPaused = paused;
      this.toggleButton?.classList.toggle('is-paused', paused);
      this.toggleButton?.setAttribute('aria-pressed', paused ? 'true' : 'false');
      this.toggleButton?.setAttribute(
        'aria-label',
        paused ? this.toggleButton.dataset.playLabel : this.toggleButton.dataset.pauseLabel,
      );

      if (paused) {
        this.stop();
      } else {
        this.start();
      }
    }

    createLoopClone() {
      const clone = this.slides[0].cloneNode(true);

      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-announcement-slide-clone', '');
      clone.removeAttribute('data-announcement-slide');
      clone.removeAttribute('data-announcement-slide-link');
      clone.removeAttribute('data-block-id');
      clone.removeAttribute('data-shopify-editor-block');
      clone.removeAttribute('role');
      clone.removeAttribute('tabindex');
      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });

      this.track.append(clone);
      this.loopClone = clone;
    }

    handleTransitionEnd(event) {
      if (event.target !== this.track || event.propertyName !== 'transform' || this.currentSlide < this.slideCount) {
        return;
      }

      this.resetActiveSlide();
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.stop();
        return;
      }

      this.updateCountdowns();
      this.resetActiveSlide();
      this.start();
    }

    resetActiveSlide() {
      if (!this.track) return;
      this.track.style.transition = 'none';
      this.currentSlide = this.slideCount ? this.currentSlide % this.slideCount : 0;
      this.setActiveSlide(this.currentSlide);
      this.track.offsetHeight;
      this.track.style.transition = '';
    }

    handleClick(event) {
      if (event.target.closest('[data-announcement-toggle]')) {
        return;
      }

      const slide = event.target.closest('[data-announcement-slide-link]');

      if (!slide || event.target.closest('a')) {
        return;
      }

      window.location.href = slide.dataset.announcementSlideLink;
    }

    handleKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      const slide = event.target.closest('[data-announcement-slide-link]');

      if (!slide || event.target.closest('a')) {
        return;
      }

      event.preventDefault();
      window.location.href = slide.dataset.announcementSlideLink;
    }

    handleToggleClick() {
      this.setPaused(!this.isPaused);
    }

    setActiveSlide(index) {
      this.track.style.setProperty('--announcement-bar-active-slide', index);
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SECTION_SELECTOR = '.custom-section--richtext-layout-grid';
    const RICH_TEXT_SELECTOR = '.rt-body, .metafield-rich_text_field';
    const PAIR_HEADING_SELECTOR = 'h3, h4';
    const MAX_PAIRS = 4;

    function applyRichtextPairs(sectionEl) {
      const richTextEls = sectionEl.querySelectorAll(RICH_TEXT_SELECTOR);

      richTextEls.forEach((richTextEl) => {
        if (richTextEl.dataset.richtextPairsApplied === 'true') return;

        const children = Array.from(richTextEl.children);
        if (!children.length) return;

        const onlyParagraphs = children.every((child) => child.matches && child.matches('p'));
        if (onlyParagraphs) {
          const pairGrid = document.createElement('div');
          pairGrid.className = 'custom-section__richtext-pairs custom-section__richtext-pairs--paragraphs-only';

          children.forEach((paragraph) => {
            const pair = document.createElement('div');
            pair.className = 'custom-section__richtext-pair';
            pair.appendChild(paragraph);
            pairGrid.appendChild(pair);
          });

          richTextEl.innerHTML = '';
          richTextEl.appendChild(pairGrid);
          richTextEl.dataset.richtextPairsApplied = 'true';
          return;
        }

        const usedIndexes = new Set();
        const pairs = [];

        for (let i = 0; i < children.length - 1 && pairs.length < MAX_PAIRS; i += 1) {
          if (usedIndexes.has(i)) continue;

          const heading = children[i];
          const paragraph = children[i + 1];

          if (heading.matches(PAIR_HEADING_SELECTOR) && paragraph && paragraph.matches('p')) {
            pairs.push([heading, paragraph]);
            usedIndexes.add(i);
            usedIndexes.add(i + 1);
            i += 1;
          }
        }

        if (!pairs.length) return;

        const pairGrid = document.createElement('div');
        pairGrid.className = 'custom-section__richtext-pairs';

        pairs.forEach(([heading, paragraph]) => {
          const pair = document.createElement('div');
          pair.className = 'custom-section__richtext-pair';
          pair.appendChild(heading);
          pair.appendChild(paragraph);
          pairGrid.appendChild(pair);
        });

        const remainingNodes = children.filter((_, idx) => !usedIndexes.has(idx));
        const introNodes = [];
        const remainingAfterIntro = [];

        for (let i = 0; i < remainingNodes.length; i += 1) {
          const node = remainingNodes[i];
          const nextNode = remainingNodes[i + 1];

          if (
            node.matches &&
            node.matches('h1, h2') &&
            nextNode &&
            nextNode.matches &&
            nextNode.matches('p')
          ) {
            introNodes.push(node, nextNode);
            i += 1;
          } else {
            remainingAfterIntro.push(node);
          }
        }

        richTextEl.innerHTML = '';
        introNodes.forEach((node) => richTextEl.appendChild(node));
        richTextEl.appendChild(pairGrid);
        remainingAfterIntro.forEach((node) => richTextEl.appendChild(node));
        richTextEl.dataset.richtextPairsApplied = 'true';
      });
    }

    function init() {
      document.querySelectorAll(SECTION_SELECTOR).forEach(applyRichtextPairs);
    }

    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"]) return;
  try {
    
  class MarqueeBanner extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-marquee-track]');
      this.toggleButton = this.querySelector('[data-marquee-toggle]');
      this.slides = Array.from(this.querySelectorAll('[data-marquee-slide]'));
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.currentSlide = 0;
      this.slideCount = this.slides.length;
      this.isPaused = false;
      this.onTransitionEnd = this.handleTransitionEnd.bind(this);
      this.onClick = this.handleClick.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);
      this.onToggleClick = this.handleToggleClick.bind(this);
      this.onVisibilityChange = this.handleVisibilityChange.bind(this);

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.toggleButton?.addEventListener('click', this.onToggleClick);
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      if (!this.track || this.slides.length < 2 || this.reducedMotion.matches) {
        return;
      }

      this.createLoopClone();
      this.track.addEventListener('transitionend', this.onTransitionEnd);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onVisibilityChange);

      if (this.track) {
        this.track.removeEventListener('transitionend', this.onTransitionEnd);
      }

      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.toggleButton?.removeEventListener('click', this.onToggleClick);
    }

    start() {
      this.stop();
      if (document.hidden || this.isPaused || this.slideCount < 2 || this.reducedMotion.matches) {
        return;
      }

      const interval = Number(this.dataset.interval) || 5000;

      this.timer = window.setInterval(() => {
        if (document.hidden) {
          this.stop();
          return;
        }
        if (this.currentSlide >= this.slideCount) this.resetActiveSlide();
        this.currentSlide += 1;
        this.setActiveSlide(this.currentSlide);
      }, interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    setPaused(paused) {
      this.isPaused = paused;
      this.toggleButton?.classList.toggle('is-paused', paused);
      this.toggleButton?.setAttribute('aria-pressed', paused ? 'true' : 'false');
      this.toggleButton?.setAttribute(
        'aria-label',
        paused ? this.toggleButton.dataset.playLabel : this.toggleButton.dataset.pauseLabel,
      );

      if (paused) {
        this.stop();
      } else {
        this.start();
      }
    }

    createLoopClone() {
      const clone = this.slides[0].cloneNode(true);

      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-marquee-slide-clone', '');
      clone.removeAttribute('data-marquee-slide');
      clone.removeAttribute('data-marquee-slide-link');
      clone.removeAttribute('role');
      clone.removeAttribute('tabindex');
      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });

      this.track.append(clone);
    }

    handleTransitionEnd(event) {
      if (event.target !== this.track || event.propertyName !== 'transform' || this.currentSlide < this.slideCount) {
        return;
      }

      this.resetActiveSlide();
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.stop();
        return;
      }

      this.resetActiveSlide();
      this.start();
    }

    resetActiveSlide() {
      if (!this.track) return;
      this.track.style.transition = 'none';
      this.currentSlide = this.slideCount ? this.currentSlide % this.slideCount : 0;
      this.setActiveSlide(this.currentSlide);
      this.track.offsetHeight;
      this.track.style.transition = '';
    }

    handleClick(event) {
      if (event.target.closest('[data-marquee-toggle]')) {
        return;
      }

      const slide = event.target.closest('[data-marquee-slide-link]');

      if (!slide || event.target.closest('a')) {
        return;
      }

      window.location.href = slide.dataset.marqueeSlideLink;
    }

    handleKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      const slide = event.target.closest('[data-marquee-slide-link]');

      if (!slide || event.target.closest('a')) {
        return;
      }

      event.preventDefault();
      window.location.href = slide.dataset.marqueeSlideLink;
    }

    handleToggleClick() {
      this.setPaused(!this.isPaused);
    }

    setActiveSlide(index) {
      this.track.style.setProperty('--marquee-banner-active-slide', index);
    }
  }

  if (!customElements.get('marquee-banner')) {
    customElements.define('marquee-banner', MarqueeBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nav-links"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SECTION_SELECTOR = '.nav-links';
    const LINK_SELECTOR = '.nav-links__content > a.link-block[href]';
    const CURRENT_CLASS = 'nav-links__link--current';

    function normalizePath(pathname) {
      const normalizedPath = decodeURI(pathname).replace(/\/+$/, '');
      return normalizedPath || '/';
    }

    function getLabelWidth(linkElement) {
      const visibleLabel = Array.from(linkElement.querySelectorAll('.link-block__label')).find(
        (labelElement) => window.getComputedStyle(labelElement).display !== 'none'
      );

      if (visibleLabel) {
        return visibleLabel.getBoundingClientRect().width;
      }

      const labelTextNodes = Array.from(linkElement.childNodes).filter(
        (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== ''
      );

      if (!labelTextNodes.length) return 0;

      const labelRange = document.createRange();
      labelRange.setStartBefore(labelTextNodes[0]);
      labelRange.setEndAfter(labelTextNodes[labelTextNodes.length - 1]);

      return labelRange.getBoundingClientRect().width;
    }

    function updateIndicatorWidth(linkElement) {
      linkElement.style.setProperty(
        '--nav-links-active-indicator-width',
        `${getLabelWidth(linkElement)}px`
      );
    }

    function updateCurrentLink(sectionElement) {
      const currentPath = normalizePath(window.location.pathname);

      sectionElement.querySelectorAll(LINK_SELECTOR).forEach((linkElement) => {
        const linkUrl = new URL(linkElement.href, window.location.origin);
        const isCurrent =
          linkUrl.origin === window.location.origin &&
          normalizePath(linkUrl.pathname) === currentPath;

        linkElement.classList.toggle(CURRENT_CLASS, isCurrent);

        if (isCurrent) {
          linkElement.setAttribute('aria-current', 'page');
          updateIndicatorWidth(linkElement);
        } else if (linkElement.getAttribute('aria-current') === 'page') {
          linkElement.removeAttribute('aria-current');
          linkElement.style.removeProperty('--nav-links-active-indicator-width');
        }
      });
    }

    function init(rootElement) {
      rootElement.querySelectorAll(SECTION_SELECTOR).forEach(updateCurrentLink);
    }

    init(document);

    if (document.fonts) {
      document.fonts.ready.then(() => init(document));
    }

    let resizeFrame;
    window.addEventListener('resize', () => {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(() => init(document));
    });

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches(SECTION_SELECTOR)) {
        updateCurrentLink(event.target);
      } else {
        init(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const getRecommendationsFromResponse = (text) => {
    const html = document.createElement('div');
    html.innerHTML = text;

    return html.querySelector('[data-product-recommendations-section]');
  };

  document.querySelectorAll('[data-product-recommendations-section]').forEach((productRecommendationsSection) => {
    if (productRecommendationsSection.dataset.initialized) return;
    productRecommendationsSection.dataset.initialized = 'true';

    const placeholder = productRecommendationsSection.innerHTML;
    let hasEnteredViewport = false;
    let generation = 0;
    let activeRequest = null;
    let observer = null;

    const loadRecommendations = async () => {
      const requestGeneration = ++generation;
      activeRequest?.abort();
      const controller = new AbortController();
      activeRequest = controller;
      const timeout = setTimeout(() => controller.abort(), 8000);
      productRecommendationsSection.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(productRecommendationsSection.dataset.url, { signal: controller.signal });
        if (!response.ok) throw new Error('Recommendations request failed');
        const text = await response.text();
        if (requestGeneration !== generation || !productRecommendationsSection.isConnected) return;

        const recommendations = getRecommendationsFromResponse(text);
        productRecommendationsSection.innerHTML = recommendations?.innerHTML.trim() || '';
        if (productRecommendationsSection.innerHTML) {
          productRecommendationsSection.dispatchEvent(new CustomEvent('listing:results-updated', { bubbles: true }));
        }
      } catch (error) {
        if (requestGeneration === generation) {
          productRecommendationsSection.innerHTML = '';
        }
      } finally {
        clearTimeout(timeout);
        if (requestGeneration === generation) {
          activeRequest = null;
          productRecommendationsSection.removeAttribute('aria-busy');
        }
      }
    };

    const handleColorChange = () => {
      const productId = document.querySelector('[data-product-page-loader-content] product-form[data-product-id]')?.dataset.productId;
      if (!productId || !productRecommendationsSection.isConnected) return;

      const url = new URL(productRecommendationsSection.dataset.url, window.location.origin);
      if (url.searchParams.get('product_id') === productId) return;

      generation += 1;
      activeRequest?.abort();
      activeRequest = null;
      url.searchParams.set('product_id', productId);
      productRecommendationsSection.dataset.url = `${url.pathname}${url.search}`;
      productRecommendationsSection.innerHTML = placeholder;
      productRecommendationsSection.removeAttribute('aria-busy');
      if (hasEnteredViewport) loadRecommendations();
    };

    const handleSectionUnload = (event) => {
      if (!event.target.contains(productRecommendationsSection)) return;
      generation += 1;
      activeRequest?.abort();
      observer?.disconnect();
      document.removeEventListener('product:color-change', handleColorChange);
      document.removeEventListener('shopify:section:unload', handleSectionUnload);
    };

    document.addEventListener('product:color-change', handleColorChange);
    document.addEventListener('shopify:section:unload', handleSectionUnload);

    if (!('IntersectionObserver' in window)) {
      hasEnteredViewport = true;
      loadRecommendations();
      return;
    }

    observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      hasEnteredViewport = true;
      loadRecommendations();
    }, {
      rootMargin: '0px 0px 0px 0px',
    });

    observer.observe(productRecommendationsSection);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-landing-metaobjects"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const RICH_TEXT_SELECTOR = '.seo-landing-metaobjects .rt-body, .seo-landing-metaobjects .metafield-rich_text_field';
    const IMAGE_MARKER_PATTERN = /^<image\s+(.+?)>$/i;

    function extractImageFilename(el) {
      if (!el) return '';
      const text = (el.textContent || '').replace(/\u00a0/g, ' ').trim();
      const match = text.match(IMAGE_MARKER_PATTERN);
      return match ? match[1].trim() : '';
    }

    function buildFileSrc(filename) {
      const safeName = filename.split('/').pop().trim();
      return `/cdn/shop/files/${encodeURIComponent(safeName).replace(/%2B/g, '+')}`;
    }

    function applyImageSplit(richTextEl) {
      if (richTextEl.dataset.seoLandingImageSplitApplied === 'true') return;

      const children = Array.from(richTextEl.children);
      let markerIndex = -1;
      let filename = '';

      for (let i = 0; i < children.length; i += 1) {
        const candidate = extractImageFilename(children[i]);
        if (!candidate) continue;
        markerIndex = i;
        filename = candidate;
        break;
      }

      if (markerIndex < 0 || !filename) {
        richTextEl.dataset.seoLandingImageSplitApplied = 'true';
        return;
      }

      const markerEl = children[markerIndex];
      const following = children.slice(markerIndex + 1);

      const split = document.createElement('div');
      split.className = 'seo-landing-image-split';

      const media = document.createElement('div');
      media.className = 'seo-landing-image-split__media';

      const img = document.createElement('img');
      img.src = buildFileSrc(filename);
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      media.appendChild(img);

      const content = document.createElement('div');
      content.className = 'seo-landing-image-split__content';
      following.forEach((node) => content.appendChild(node));

      split.appendChild(media);
      split.appendChild(content);
      markerEl.replaceWith(split);

      richTextEl.dataset.seoLandingImageSplitApplied = 'true';
    }

    function init() {
      document.querySelectorAll(RICH_TEXT_SELECTOR).forEach(applyImageSplit);
    }

    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
